
 
export function createLoader(show = true){
    let $loader = $('#loader')
    if($loader.length == 0){
        $loader = $(
            `<div id="loader" style="position: fixed; width: 100%; height: 100%; z-index: 10000; left: 0; top: 0; background-color: rgba(0, 0, 0, .5); text-align: center; align-items: center; display: none;">
                <div style="width: 100%; text-align: center;">
                     <div class="preloader-wrapper big active">
                        <div class="spinner-layer spinner-blue-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div><div class="gap-patch">
                                <div class="circle"></div>
                            </div><div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`).appendTo('body')
    }
    if(show)
        $loader.fadeIn('fast', function(){ $(this).css('display', 'flex')})
    else
        $loader.fadeOut('fast')
}

export function afterSubmit(data, modal = undefined, $form = undefined, $boton = undefined){
    let status      = data.status
    ,   callback    = function(status){
                        if(status.reload){
                            window.location.reload()
                            return true;
                        }
                        else if($form != undefined){
                            if($form.find('[name="g-recaptcha-response"]').length != 0){
                                obtenerCaptcha($form.attr('id'));
                            }
                        } 

                        if(status.go_to != ''){
                            window.location.href    = status.go_to       
                            return true;
                        }

                        if(status.close && modal != undefined){
                            modal.close()
                            return true;
                        }    

                        if(status.reset && $form != undefined){
                            $form.get(0).reset()
                        }
                    }

    if(typeof data.consola === 'object'){
        console.log(data.consola)
    }

    if(status.localstorage){
        for(let keys in status.localstorage){
            window.localStorage.setItem(keys,JSON.stringify(status.localstorage[keys]))
        }
    }

    if(data.messages.length != 0){
        afterSubmitToast(data.messages, function(){
            callback(status);
        });
       
    }
    else{
        callback(status);
    }

    if(typeof $boton !== 'undefined'){
        $boton.attr('data-disable', 'false') 
    }

    if(status.functions.length != 0){
        for(let k in status.functions){
            if(typeof window[status.functions[k]] === 'function'){
                window[status.functions[k]]()
            }
        }
    }
}

export function jSONInfo(config, option, callBack){
    let cnfAjax={
            url:        config.dir
        ,   type:       config.type
        ,   data:       option
        ,   dataType:   "json"
        ,   success: function(data) {           
                if(typeof callBack == 'function') callBack(data);
            }
        ,   error: function (data, status, e){
                console.log("jSONInfo - No se pudo cargar la pagina: ",data.responseText);
            }
        }
    ,   $files  = config.Files
    if($files != undefined && $files.length != 0){       
        cnfAjax.fileElementId   = $files;
        $.ajaxFileUpload(cnfAjax);
    }
    else{
         $.ajax(cnfAjax);
    } 
}

export function copyToClipboard(str){
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

function afterSubmitToast(messages, callback = undefined){
    if(messages.length == 0){
        if(typeof callback === 'function'){
            callback()
        }
    }
    else{
        let messages_str = messages.join('<br />')
        M.toast({html: messages_str, completeCallback: callback})
    }
}

export function initAutoEstashment(idElement, componentForm){
    if(!statusGoogle()){console.log('Error con Google'); return false}
    let $input = $('#' + idElement)
    if($input.length == 0) return false;

    let placeholder     = $input.attr('placeholder')
    ,   autocomplete    = new google.maps.places.Autocomplete($input[0], {types: ['establishment']});
    $input.attr('placeholder', placeholder);
    autocomplete.addListener('place_changed', function(){});
}

function statusGoogle(){
    if(typeof google !== "undefined"){
        return true;
    }
    else{
        console.log('Revisando Google')
        setTimeout(statusGoogle, 50);
    }
}

export function initModal(isMovil){
    return {dismissible         : false
        ,   preventScrolling    : isMovil ? false : true
        ,   endingTop           : '5%'
        ,   opacity             : .80
        ,   onCloseStart        :
            function(modal, trigger){
            }
        ,   onCloseEnd          :
                function(modal, trigger){
                    if(isMovil && $('.modal:visible').length == 0){
                        $('main, main + footer').css('display', 'block')
                        $("html,body").animate({scrollTop: initTop}, 200);
                    }
                }
        ,   onOpenStart         : 
                function(modal, trigger){
                    openStartModal(isMovil, modal)
                    obtenerCaptcha($(modal).find('form').first().attr('id'))

                }
        ,   onOpenEnd           :
                function(modal, trigger){
                    if(isMovil){
                        $(modal).css({top: '0%', position: 'initial'})
                        $("html,body").animate({scrollTop: '0%'}, 200);
                    }
                }
        }
}

export function openStartModal(isMovil, modal){
    if(!isMovil) return false
    initTop = $('body').scrollTop()
    $('main, main + footer').css('display', 'none')
    $(modal).css({position: 'absolute', left: '0%', top: '0%', width: '100%'})
}

export function espCalendar(){
    return {cancel:  'Cerrar'
        ,   clear:   'Limpiar'
        ,   done:    'Aceptar'
        ,   previousMonth:   '‹'
        ,   nextMonth:   '›'
        ,   months:  
                [
                  'Enero',
                  'Febrero',
                  'Marzo',
                  'Abril',
                  'Mayo',
                  'Junio',
                  'Julio',
                  'Agosto',
                  'Septiembre',
                  'Octubre',
                  'Noviembre',
                  'Diciembre'
                ]
                      
        ,   monthsShort : [
                    'Ene',
                    'Feb',
                    'Mar',
                    'Abr',
                    'May',
                    'Jun',
                    'Jul',
                    'Ago',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dic'
                ]                      
        ,   weekdays : [
                  'Domingo',
                  'Lunes',
                  'Martes',
                  'Miercoles',
                  'Jueves',
                  'Viernes',
                  'Sábado'
                ]
                      
        ,   weekdaysShort : [
                  'Dom',
                  'Lun',
                  'Mar',
                  'Mie',
                  'Jue',
                  'Vie',
                  'Sáb'
                ]                      
        , weekdaysAbbrev :  ['D','L','M','M','J','V','S']}
}

export function createCarrousel($where, fotos){
    $where.empty()
    for(let i in fotos){
        let $carr_item  = $('<div class="carousel-item white-text cbanner" />');
        $carr_item.css({'background-image': 'url(' + fotos[i].imgBig + ')'})
        $where.append($carr_item)
    }
    if(fotos.length > 1){
        $where.append(`<div class="button-set">
                            <div class="mid-container">
                                <button data-type="prev"><i class="fa fa-chevron-left"></i></button>
                                <button data-type="next"><i class="fa fa-chevron-right"></i></button>
                            </div>
                        </div>`)
    }
}

export function getItem(items, idItem, nameItem){
    for(let i in items){
        if(items[i][nameItem] == idItem) return items[i]
    }        
}

export function setNumberCero(number, defval = 0){
    return $.isNumeric(number) ? Number(number) : Number(defval)
}

export function cambioSede(locales, idResp, $carousel = undefined, $tevento = undefined, $inv_adultos = undefined, $inv_ninos = undefined, $descripcion = undefined){
    let local = getItem(locales, idResp, 'idResp')

    if($carousel !== undefined){

        let elems       = $carousel.eq(0).get(0)       
        let instance    = M.Carousel.getInstance(elems)

        if(instance != undefined){
            instance.destroy();
        }
        createCarrousel($carousel, local.fotos)
        $carousel.carousel({
            fullWidth: true,
            indicators: true
        });
    }

    if($tevento !== undefined){
        let tevento         = M.FormSelect.getInstance($tevento.get(0))
        $tevento.empty()
        $tevento.append('<option value="" disabled selected>Tipo de evento</option>')   
        tevento.destroy();      
        for(let k in local.tevento){
            $tevento.append('<option value="' + local.tevento[k].idTEvento + '" >' + local.tevento[k].nombreTEvento + '</option>')
        }
        $tevento.formSelect();
    }
    if($inv_adultos !== undefined){
        $inv_adultos.attr({min: local.s_minAdResp, max: local.s_maxAdResp})
        $inv_adultos.val(local.s_minAdResp)
    }

    if($inv_ninos !== undefined){
        $inv_ninos.attr({min: local.s_minNiResp, max: local.s_maxNiResp})    
        $inv_ninos.val(local.s_minNiResp)
    }

    if($descripcion !== undefined){
        $descripcion.text(local.descrResp)
    }
    if($inv_adultos !== undefined || $inv_ninos !== undefined || $descripcion !== undefined){
        M.updateTextFields()
    }

    return local
}

export function obtenerCaptcha(formId){
    if(!_CAPTCHA)     return false; 

    let $form     = $('#' + formId)
    ,    $btn     = $form.find('[data-send="' + formId + '"]')
    $btn.addClass('disabled').attr('data-disable', 'true')
    grecaptcha.ready(function() {
        grecaptcha.execute(_CAPTCHA_WEBS, {action: $form.attr('action')}).then(function(token) {
            let $input  = $form.find('[name="g-recaptcha-response"]');
            if($input.length == 0) $input = $('<input type="hidden" name="g-recaptcha-response" />').appendTo($form)
            $input.val(token)
            $btn.removeClass('disabled').attr('data-disable', 'false')
        });
    });
}




// WEBPACK FOOTER //
// ./src/js/include/global.js